<div class="exception-body">

    <div class="exception-topbar">
        <a href="javascript:void(0)" (click)="openLink('HOMPAGE_BASE_URL','','_self');" class="logo">
            <img [src]="this.logo_url" alt="eglobaldoctors" />
        </a>
    </div>

    <div class="container top-bottom-space">
        <div class="ui-lg-6">
            <div class="exception-panel" style="padding-top: 10%;">
                <h1 class="exception-summary">Access Denied</h1>
                <p class="exception-detail">
                    <b>You don't have the necessary permissons.</b><br>
                    <!-- Try to search again or use the Go to Dashboard button below. -->
                </p>
                <div>

                    <!-- <button type="button" pButton label="Go To Dashboard" [routerLink]="['/']"></button> -->
                    <button type="button" pButton label="Go To Dashboard" [routerLink]="['/', this.slug]"></button>
                </div>
            </div>
        </div>
    </div>
</div>
<app-home-footer></app-home-footer>